import { render, staticRenderFns } from "./index.vue?vue&type=template&id=be561eea&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\iot_vehicle\\iot_frontend\\iot_supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('be561eea')) {
      api.createRecord('be561eea', component.options)
    } else {
      api.reload('be561eea', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=be561eea&", function () {
      api.rerender('be561eea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ads/reward/index.vue"
export default component.exports